export const langText: any = {
    us: {
        also_like: 'You may also like:',
        affirm_text: '*Six interest-free installments',
        link_more: 'Learn More',
        link_buy: 'Buy Now',
        sold_out: 'Sold Out',
    },
    de: {
        also_like: 'Sie benötigen außerdem:',
        affirm_text: 'Zinsfreie Zahlung in 6 Raten',
        link_more: 'Mehr erfahren',
        link_buy: 'Jetzt kaufen',
        sold_out: 'Ausverkauft',
    },
    fr: {
        also_like: 'Les clients ayant acheté cet article ont également acheté :',
        affirm_text: '*Six interest-free installments',
        link_more: 'En savoir plus',
        link_buy: 'Acheter maintenant',
        sold_out: 'Épuisé',
    },
    it: {
        also_like: 'Altri prodotti di cui potresti avere bisogno:',
        affirm_text: '*Six interest-free installments',
        link_more: 'Saperne di più',
        link_buy: 'Acquista ora',
        sold_out: 'Esaurito',
    },
    es: {
        also_like: 'Puede que también necesites:',
        affirm_text: '*Six interest-free installments',
        link_more: 'Más información',
        link_buy: 'Comprar ahora',
        sold_out: 'Agotado',
    },
};
